module.exports = __webpack_public_path__ + "static/media/new-message.74fa1195.png";